import { type DefaultSeoProps } from 'next-seo';

const config: DefaultSeoProps = {
  titleTemplate: '%s | Sphere: Your Web3 NFT Marketplace for Gaming & Trading',
  defaultTitle: 'Sphere: Your Web3 NFT Marketplace for Gaming & Trading',
  openGraph: {
    siteName: 'Sphere: Your Web3 NFT Marketplace for Gaming & Trading',
    images: [
      { url: `${process.env.NEXT_PUBLIC_HOST_URL}/opengraph-image.png`, width: 1200, height: 630 },
    ],
  },
  twitter: {
    site: '@GetOnSphere',
    cardType: 'summary_large_image',
  },
};

export default config;
